<div class="people-list">
  <people-list-item *ngFor="let person of people" [person]="person">
    <ng-container *ngIf="peopleListOf | async as peopleListType">
      <people-role-selector [roles]="roles" [person]="person" [peopleListOf]="peopleListType" [showRoleSelector]="showRoleSelector"></people-role-selector>
    </ng-container>
  </people-list-item>
</div>
